import axios_instance from "../axios.config";

const RegisterNewUser = async (credentials: any) => {
  const {
    id,
    username,
    password,
    role,
    permissions,
    staff_id = "",
  } = credentials;
  const payload = {
    id,
    username,
    password,
    role,
    permissions,
    staff_id,
  };
  const response = await axios_instance.post("/auth/registeruser", payload);
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

const Login = async (credentials: any) => {
  const { username, password } = credentials;
  const payload = {
    username,
    password,
  };
  const response = await axios_instance.post("/auth/login", payload);
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

const UpdatePasswordv2 = async (credentials: any) => {
  const { username, oldpassword, newpassword } = credentials;
  const payload = {
    username,
    oldpassword,
    newpassword,
  };
  const response = await axios_instance.post(
    "/auth/update-passwordv2",
    payload
  );
  if (
    response?.data?.status === "SUCCESS" ||
    response?.data?.status === "FAIL"
  ) {
    return response.data;
  } else {
    return {};
  }
};

const FetchUser = async (staff_id: string) => {
  const payload = {
    staff_id,
  };
  const response = await axios_instance.post("/auth/fetchuser", payload);
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

const UpdatePassword = async (updatedObj: any) => {
  const { id, password } = updatedObj;
  const payload = {
    id,
    password,
  };
  const response = await axios_instance.post("/auth/update-password", payload);
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

const GetAllTeachersPasswords = async () => {
  const response = await axios_instance.get("/auth/get-all-creds-teacher", {
    responseType: "blob",
  });

  const contentType = response.headers["content-type"];

  if (contentType && contentType.includes("application/json")) {
    // If backend sent a JSON response inside a blob (e.g. NO_RECORDS)
    const text = await response.data.text(); // Convert blob to text
    const json = JSON.parse(text);
    return json; // { status: 'NO_RECORDS', message: '...' }
  } else {
    // Otherwise assume it's CSV blob
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "teacher_credentials.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
};

export {
  Login,
  FetchUser,
  RegisterNewUser,
  UpdatePassword,
  UpdatePasswordv2,
  GetAllTeachersPasswords,
};
